import { IconReply } from '@consta/icons/IconReply'
import { IconShare } from '@consta/icons/IconShare'
import type { ButtonPropSize, ButtonPropView } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import { withTooltip } from '@consta/uikit/withTooltip'
import { FormattedTooltipContent } from '@library/components'
import type { Nullable, ProjectState } from 'common/types'
import type { FC } from 'react'

const ButtonWithTooltip = withTooltip({
  appearTimeout: 200,
  direction: 'downCenter',
  mode: 'mouseover',
})(Button)

type PublishButtonProps = {
  size?: ButtonPropSize
  view?: ButtonPropView
  state: Nullable<ProjectState> | undefined
  onClick: VoidFunction
}

export const PublishButton: FC<PublishButtonProps> = ({
  state,
  size = 'xs',
  view = 'clear',
  onClick,
}) => {
  const isPrivate = state === 'Private'

  const PublishIcon = isPrivate ? IconReply : IconShare

  return (
    <ButtonWithTooltip
      view={view}
      size={size}
      onlyIcon={true}
      iconLeft={props => <PublishIcon {...props} view={isPrivate ? props.view : 'link'} />}
      tooltipProps={{
        tooltipContent: (
          <FormattedTooltipContent
            title="Публикация проекта"
            description={isPrivate ? 'Проект приватный' : 'Проект публичный'}
          />
        ),
      }}
      onClick={onClick}
    />
  )
}
